























import BaseComponent from "@/asdcom/BaseComponent";
import { Prop, Component, Watch, Emit } from "vue-property-decorator";
import { IHeader } from "@/store/models/staff/IHeader";
import ApplicantMailComponent from '@/components/vcponlineok/staff-user/applicant-mail-component.vue';
import { ButtonList } from "sweetalert/typings/modules/options/buttons";
import { MailItemDto, MailItemLogDto, RetrieveMailItemLogStaffInput } from "@/asdcom/apiproxy/apiproxy.dto";

@Component({
  components: {
    ApplicantMailComponent
  }
})
export default class ApplicantMailListComponent extends BaseComponent {
  isItemView: boolean = false;
  logList: MailItemLogDto[] = [];
  selectedMailItemModel = new MailItemDto();
  @Prop({default: () => []}) viewModel: Array<any>;

  headers: IHeader[] = [
    { text: "Date Received", value: "creationTime", align: "center" },
    { text: "Status", value: "isOpened", align: "center" },
    { text: "Claim Number", value: "claimNumber", align: "center" },
    { text: "Name", value: "documentName", align: "center" },
  ];

  get listData() {
    return this.viewModel;
  }

  private async onListRowClick(item: MailItemDto) {
    const input = new RetrieveMailItemLogStaffInput({mailItemId: item.id});
    const ret = await this.$appsvs.staffVpBox.retrieveMailItemLogStaff(input);
    this.logList = ret;
    this.selectedMailItemModel = item;
    this.isItemView = true;
  }

}
